import { lazy, Suspense } from 'react';
import { type RouteObject } from 'react-router';
import { Guard } from '@/modules/shared/components/guard';

const ResponsavelHome = lazy(() => import('./pages/home'));

const RelatoriosLayout = lazy(() => import('./pages/relatorios/_layout'));
const RelatoriosIndex = lazy(() => import('./pages/relatorios/index'));
const RelatorioProvas = lazy(() => import('./pages/relatorios/relatorio-provas'));
const RelatorioRedacoes = lazy(() => import('./pages/relatorios/relatorio-redacoes'));
const RelatorioQuizzes = lazy(() => import('./pages/relatorios/relatorio-quizzes'));
const Visualizar = lazy(() => import('./pages/relatorios/visualizar'));

const HistoricoProvaResponsavel = lazy(() => import('./pages/correcao/historico-prova'));
const HistoricoRedacaoResponsavel = lazy(() => import('./pages/correcao/historico-redacao'));

const ResponsavelGuard = ({ children, allowedRoles }: {
  children: React.ReactNode;
  allowedRoles: any[];
}) => (
  <Suspense fallback={<div className="min-h-screen" />}>
    <Guard allowedRoles={allowedRoles}>
      {children}
    </Guard>
  </Suspense>
);

const ROTA_RESPONSAVEL_PREVIEW: any[] = ['RESPONSAVEL', 'SUPER', 'ADM', 'PROFESSOR', 'ALUNO'];

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <ResponsavelGuard allowedRoles={['RESPONSAVEL', 'SUPER', 'ADM']}>
        <ResponsavelHome />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Home' }
  },
  {
    path: '/correcao/responsavel/historico-prova',
    element: (
      <ResponsavelGuard allowedRoles={ROTA_RESPONSAVEL_PREVIEW}>
        <HistoricoProvaResponsavel />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Resultado da Prova' }
  },
  {
    path: '/correcao/responsavel/historico-prova/lote/:loteUuid',
    element: (
      <ResponsavelGuard allowedRoles={ROTA_RESPONSAVEL_PREVIEW}>
        <HistoricoProvaResponsavel />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Alunos do Lote — Prova' }
  },
  {
    path: '/correcao/responsavel/historico-prova/lote/:loteUuid/aluno/:alunoIndex',
    element: (
      <ResponsavelGuard allowedRoles={ROTA_RESPONSAVEL_PREVIEW}>
        <HistoricoProvaResponsavel />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Resultado da Prova' }
  },
  {
    path: '/correcao/responsavel/historico-redacao',
    element: (
      <ResponsavelGuard allowedRoles={ROTA_RESPONSAVEL_PREVIEW}>
        <HistoricoRedacaoResponsavel />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Resultado da Redação' }
  },
  {
    path: '/correcao/responsavel/historico-redacao/lote/:loteUuid',
    element: (
      <ResponsavelGuard allowedRoles={ROTA_RESPONSAVEL_PREVIEW}>
        <HistoricoRedacaoResponsavel />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Alunos do Lote — Redação' }
  },
  {
    path: '/correcao/responsavel/historico-redacao/lote/:loteUuid/aluno/:alunoIndex',
    element: (
      <ResponsavelGuard allowedRoles={ROTA_RESPONSAVEL_PREVIEW}>
        <HistoricoRedacaoResponsavel />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Resultado da Redação' }
  },
  {
    path: '/relatorios',
    element: (
      <ResponsavelGuard allowedRoles={['RESPONSAVEL', 'SUPER', 'ADM', 'PROFESSOR', 'ALUNO']}>
        <RelatoriosLayout />
      </ResponsavelGuard>
    ),
    handle: { crumb: 'Relatórios' },
    children: [
      {
        index: true,
        element: <RelatoriosIndex />,
      },
      {
        path: 'provas',
        element: <RelatorioProvas />,
        handle: { crumb: 'Provas e Simulados' }
      },
      {
        path: 'redacoes',
        element: <RelatorioRedacoes />,
        handle: { crumb: 'Redações' }
      },
      {
        path: 'quizes',
        element: <RelatorioQuizzes />,
        handle: { crumb: 'Quizzes Gerados' }
      },
      {
        path: ':id',
        element: <Visualizar />,
        handle: { crumb: 'Visualizar Relatório' }
      },
      {
        path: 'aluno/:alunoId',
        element: <RelatoriosIndex />,
        handle: { crumb: 'Relatório do Aluno' }
      }
    ]
  }
];

export default routes;
